<template>
  <div
    class="container wrapper"
  >
    <div v-if="sortedProducts.length">
      <CartList
        :products="getSortedProduct"
        :remove-from-cart="removeFromCartHandler"
        :total-price="cart.totalPrice"
        :new-total="newTotal"
        :show-buttons="true"
        :shipping="null"
      />
      <div
        v-if="userDataErrors.noProducts"
        class="alert alert-danger"
      >
        {{ strings.cart.noProductsError_ }}
      </div>
      <p
        class="have-discount"
        @click="haveDiscount = !haveDiscount"
      >
        {{ strings.cart.discountCode_ }}
      </p>
      <div v-if="haveDiscount">
        <div class="form-group input-custom">
          <input
            id="inputName"
            v-model="discount"
            type="text"
            class="form-control"
            :class="{'is-invalid': discountError}"
            aria-describedby="nameHelp"
            placeholder="Zniżka"
          >
          <span
            v-if="discountError"
            class="alert text-danger"
          >{{ strings.cart.discountCodeInactive_ }}</span>
        </div>
        <button
          type="button"
          class="btn button-submit"
          @click="checkDiscount"
        >
          {{ strings.cart.calc_ }}
        </button>
      </div>
      <div class="form-wrapper">
        <div class="form-title">
          <p> {{ strings.cart.makeOrder_ }}</p>
        </div>
        <form>
          <div class="form-group input-custom">
            <input
              id="inputName"
              v-model="userData.name"
              type="text"
              class="form-control"
              :class="{'is-invalid': userDataErrors.name}"
              aria-describedby="nameHelp"
              :placeholder="strings.form.name_"
            >
            <span
              v-if="userDataErrors.name"
              class="alert text-danger"
            >{{ strings.form.nameError_ }}</span>
          </div>
          <div class="form-group input-custom">
            <input
              id="inputSurname"
              v-model="userData.surname"
              type="text"
              class="form-control"
              :class="{'is-invalid': userDataErrors.surname}"
              :placeholder="strings.form.surname_"
            >
            <span
              v-if="userDataErrors.surname"
              class="alert text-danger"
            >{{ strings.form.surnameError_ }}</span>
          </div>
          <div class="form-group input-custom">
            <input
              id="inputAddress"
              v-model="userData.address"
              type="text"
              class="form-control"
              :class="{'is-invalid': userDataErrors.address}"
              :placeholder="strings.form.address_"
            >
            <span
              v-if="userDataErrors.address"
              class="alert text-danger"
            >{{ strings.form.addressError_ }}</span>
          </div>
          <div class="form-group input-custom">
            <input
              id="inputCity"
              v-model="userData.city"
              type="text"
              class="form-control"
              :class="{'is-invalid': userDataErrors.city}"
              :placeholder="strings.form.city_"
            >
            <span
              v-if="userDataErrors.city"
              class="alert text-danger"
            >{{ strings.form.cityError_ }}</span>
          </div>
          <div class="form-group input-custom">
            <input
              id="inputCode"
              v-model="userData.postCode"
              type="text"
              class="form-control"
              :class="{'is-invalid': userDataErrors.postCode}"
              :placeholder="strings.form.code_"
            >
            <span
              v-if="userDataErrors.postCode"
              class="alert text-danger"
            >{{ strings.form.codeError_ }}</span>
          </div>
          <div class="form-group input-custom">
            <input
              id="inputEmail"
              v-model="userData.email"
              type="text"
              class="form-control"
              :class="{'is-invalid': userDataErrors.email}"
              :placeholder="strings.form.email_"
            >
            <span
              v-if="userDataErrors.email"
              class="alert text-danger"
            >{{ strings.form.emailError_ }}</span>
          </div>
          <div class="form-group input-custom">
            <input
              id="inputPhone"
              v-model="userData.phone"
              type="text"
              class="form-control"
              :class="{'is-invalid': userDataErrors.phone}"
              :placeholder="strings.form.phone_"
            >
            <span
              v-if="userDataErrors.phone"
              class="alert text-danger"
            >{{ strings.form.phoneError_ }}</span>
          </div>
          <div class="form-check input-radio">
            <input
              id="exampleCheck1"
              v-model="userData.rules"
              type="checkbox"
              class="form-check-input"
            >
            <label
              class="form-check-label"
              for="exampleCheck1"
            >{{ strings.form.rules_ }}</label>
            <span
              v-if="userDataErrors.rules"
              class="alert text-danger"
            >{{ strings.form.rulesError_ }}</span>
          </div>
          <button
            type="button"
            class="btn button-submit"
            @click="validateCart"
          >
            {{ strings.form.submit_ }}
          </button>
        </form>
      </div>
    </div>
    <div
      v-else
      class="no-products"
    >
      <p>{{ strings.cart.cartEmpty_ }}</p>
    </div>
  </div>
</template>

<script>
import CartList from '@/components/shop/CartProducts.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Home',
  components: {
    CartList
  },
  data () {
    return {
      haveDiscount: false,
      newTotal: null,
      discount: null,
      discountId: null,
      discountError: false,
      sortedProducts: [],
      productsIdToValidate: [],
      userData: {
        name: '',
        surname: '',
        address: '',
        postCode: '',
        phone: '',
        city: '',
        email: '',
        rules: false
      },
      userDataErrors: {
        name: false,
        surname: false,
        address: false,
        postCode: false,
        city: false,
        email: false,
        phone: false,
        noProducts: false,
        rules: false
      },
      networkError: false
    }
  },
  computed: {
    ...mapGetters([
      'cart',
      'order',
      'strings'
    ]),
    getSortedProduct () {
      return this.sortedProducts
    }
  },

  methods: {
    ...mapActions([
      'removeFromCart',
      'validateOrder',
      'calculateDiscount'
    ]),
    sortItems () {
      this.sortedProducts = []
      for (let i = 0; i < this.cart.products.length; i++) {
        const index = this.sortedProducts.findIndex(x => x.product._id === this.cart.products[i].product._id)
        if (index === -1) {
          const sizeArray = []
          sizeArray.push({
            size: this.cart.products[i].size,
            amount: 1
          })
          this.sortedProducts.push({
            product: this.cart.products[i].product,
            sizes: sizeArray
          })
        } else {
          const sizeIndex = this.sortedProducts[index].sizes.findIndex(x => x.size === this.cart.products[i].size)
          if (sizeIndex === -1) {
            this.sortedProducts[index].sizes.push({
              size: this.cart.products[i].size,
              amount: 1
            })
          } else {
            this.sortedProducts[index].sizes[sizeIndex].amount++
          }
        }
      }
      const finalSort = []
      this.sortedProducts.forEach(product => {
        product.sizes.forEach(size => {
          finalSort.push({
            product: product.product,
            amount: size.amount,
            size: size.size
          })
        })
      })
      this.sortedProducts = finalSort
    },
    removeFromCartHandler (productId, size) {
      this.removeFromCart({ productId, size })
      this.sortItems()
      this.checkDiscount(false)
    },
    unsetErrors () {
      Object.keys(this.userDataErrors)
        .forEach(key => { this.userDataErrors[key] = false })
    },
    validateUserData () {
      this.unsetErrors()
      if (!this.userData.name) this.userDataErrors.name = true
      if (!this.userData.surname) this.userDataErrors.surname = true
      if (!this.userData.address) this.userDataErrors.address = true
      if (!this.userData.postCode) this.userDataErrors.postCode = true
      if (!this.userData.email) this.userDataErrors.email = true
      if (!this.userData.phone) this.userDataErrors.phone = true
      if (!this.userData.city) this.userDataErrors.city = true
      if (!this.sortedProducts.length) this.userDataErrors.noProducts = true
      if (!this.userData.rules) this.userDataErrors.rules = true
      let isError = false

      Object.keys(this.userDataErrors).forEach(key => {
        if (this.userDataErrors[key]) {
          isError = true
        }
      })
      if (isError) return false
      return true
    },
    async validateCart () {
      if (this.validateUserData()) {
        const order = this.userData
        delete order.rules
        order.totalPrice = this.cart.totalPrice
        this.discountId ? order.discount = this.discountId : order.discount = null
        order.products = this.sortedProducts.map(product => {
          return {
            id: product.product._id,
            amount: product.amount,
            size: product.size
          }
        })

        const result = await this.validateOrder(order)
        if (result.status === 201) { this.$router.push({ name: 'Summarise' }) } else if (result.status === 400) {
          this.$message(
            this,
            this.strings.form.errors.error_,
            `${this.strings.form.errors.noItems_}: ${result.data?.error?.message}`,
            'danger'
          )
        } else {
          this.$message(
            this,
            this.strings.form.errors.error_,
            this.strings.form.errors.incorrectData_,
            'danger'
          )
        }
      }
    },
    async checkDiscount (displayError = true) {
      this.discountError = false
      const result = await this.calculateDiscount(this.discount)
      if (result.status === 200) {
        if (result.data.discount?.discount > 0 && result.data.discount?.discount < 100) {
          this.discountId = result.data.discount._id
          this.newTotal = parseFloat(((1 - result.data.discount.discount / 100) * this.cart.totalPrice), 2)
        }
      } else {
        if (displayError) {
          this.$message(
            this,
            this.strings.form.errors.badCode_,
            this.strings.form.errors.inActiveCode_,
            'danger'
          )
        }
      }
    }
  },
  mounted () {
    this.sortItems()
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  padding-top: 100px;
  height: 100%;
}

.form-title p {
  font-size: 1.3rem;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 30px;
}
.form-wrapper {
  margin-top: 80px;
}
.input-custom {
  color: #000000;
}
.input-custom input {
  border-radius: 0;
  color: #000000;
  letter-spacing: 2px;
  border: 1px solid #000000;
}
.input-radio {
  text-align: left;
  color: #000000;
  letter-spacing: 2px;
}
.button-submit {
  margin-top: 20px;
  width: 100%;
  background-color: #000000;
  border: 1px solid #000000;
  border-radius: 0;
  color: #ffffff;
  margin-bottom: 40px;
}
.have-discount {
  text-align: left;
  font-size: 0.9rem;
  letter-spacing: 2px;
  cursor: pointer;
}
.no-products {
  margin-top: 100px
}
@media (min-width: 992px) {
  .wrapper {
    max-width: 800px;
  }
}

.info {
  position: absolute;
  bottom: 50px;
  right: 20px;
  width: 30%;
  text-align: center;
}
</style>
